/** When your routing table is too long, you can split it into small modules**/

// 系统管理

import Layout from '@/views/layout/Layout'
import { fetchDeviceList } from '@/api/device'
const mtDeviceManage = {
  path: '/mtDeviceManage',
  component: Layout,
  alwaysShow: true,
  name: '车辆列表',
  redirect: 'noredirect',
  meta: {
    title: '车辆列表',
    icon: 'list',
    resources: 'mtDeviceManage'
  },
  children: [
    {
      path: 'detail/:id(\\d+)',
      component: () => import('@/views/baidumap/detail'),
      name: 'device',
      hidden: true,
      meta: { title: 'device', icon: '', noCache: true, resources: 'accountList' }
    },
    
    {
      path: 'detail/list',
      component: () => import('@/views/device/list'),
      name: '设备列表',
      meta: { title: '设备列表', icon: 'tree', noCache: true, resources: 'accountList' }
    },
   
  ]
}
// var children = [{
//   path: 'detail/:id(\\d+)',
//   component: () => import('@/views/baidumap/detail'),
//   name: 'device',
//   hidden: true,
//   meta: { title: 'device', icon: '', noCache: true, resources: 'accountList' }
// }]
// fetchDeviceList({}).then(response => {
//   console.log('========fetchDeviceList')
//   console.log(response)

//   for (let i = 0; i < response.data.list.length; i++) {
//     var element = response.data.list[i]

//     var ele =
//       {
//         path: 'detail/' + element.id,
//         component: () => import('@/views/baidumap/detail'),
//         name: element.name,
//         meta: { title: element.name, icon: '', noCache: true, resources: 'accountList' }
//       }
//     children.push(ele)
//     continue
//   }
//   mtDeviceManage.children = children
// })

export default mtDeviceManage
